import commonApi from "@/api/common/commonApi";
import { ElMessage } from "element-plus";
import { ref } from "vue";
// import { machineVal, NvcReject, yourRegisterRequest } from "./useNvc";
import { clientType } from "@/config/config";
import { isMob } from "@/utils/validator";

const apis = {
  1: commonApi.getVerificationCode,
  2: commonApi.GetRegisterVerificationCode,
};

export default (number: number, type: keyof typeof apis = 1) => {
  const time = ref(number);
  const disabled = ref<boolean>(false);
  const isSlidingBlock = ref<boolean>(false);
  const api = apis[type];
  // 点击获取验证码
  const getVerificationCode = async (phone: string, nvc?: string, getParams = async () => ({})) => {
    await verify(phone);
    const urlObj = await getParams();
    const { status, data } = await api({ phone, machineVal: "123456", clientType, ...urlObj, secret: sessionStorage.getItem("Secret") });
    if (status == 200) {
      disabled.value = true;
      timer(number);
      ElMessage({
        message: "已发送验证码(5分钟有效期),请注意查收",
        type: "success",
      });
    } else {
      // await yourRegisterRequest(Number(data.statusVal), "验证").catch((err: NvcReject) => {
      //   isSlidingBlock.value = true;
      //   return Promise.reject(err);
      // });
    }
  };
  /** 验证手机号 */
  const verify = (phone: string) => {
    return new Promise<void>((resolve) => {
      if (!phone) ElMessage({ message: "请输入手机号", type: "warning" });
      else if (isMob.test(phone)) resolve();
      else ElMessage({ message: "请输入合法手机号", type: "warning" });
    });
  };
  //发送手机验证码倒计时
  const timer = (number: number) => {
    time.value = number;
    const timer = setInterval(() => {
      time.value--;
      if (time.value <= 0) {
        clearInterval(timer);
        disabled.value = false;
      }
    }, 1000);
  };
  return { getVerificationCode, time, disabled, isSlidingBlock };
};
